import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef } from 'react';
import usePdfCapture from './use-pdf-capture';
type OffscreenPdfProps = {
  children: ReactNode;
  filename: string;
  onDone: () => void;
};
const decodeImages = async (el: HTMLElement): Promise<void> => {
  await Promise.all(Array.from(el.querySelectorAll('img')).map(img => img.decode()));
};
const OffscreenPdf = t0 => {
  const $ = _c(7);
  const {
    children,
    filename,
    onDone
  } = t0;
  const capturePdf = usePdfCapture();
  const ref = useRef(null);
  const started = useRef(false);
  let t1;
  let t2;
  if ($[0] !== capturePdf || $[1] !== filename || $[2] !== onDone) {
    t1 = () => {
      const el = ref.current;
      if (started.current || !el) {
        return;
      }
      started.current = true;
      capturePdf(el, {
        filename,
        waitForReady: decodeImages
      }).finally(onDone);
    };
    t2 = [capturePdf, filename, onDone];
    $[0] = capturePdf;
    $[1] = filename;
    $[2] = onDone;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== children) {
    t3 = <div aria-hidden={true} className="fixed h-0 w-[760px] overflow-hidden"><div ref={ref}>{children}</div></div>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default OffscreenPdf;